// extracted by mini-css-extract-plugin
export default {"productDescription":"fda-z","featuredDescription":"gda-z","description":"hda-z","more":"ida-z","descriptionSku":"jda-z"};